import { render, staticRenderFns } from "./OnboardingContentsItems.vue?vue&type=template&id=3b1b6fc2"
import script from "./OnboardingContentsItems.vue?vue&type=script&lang=js"
export * from "./OnboardingContentsItems.vue?vue&type=script&lang=js"
import style0 from "./OnboardingContentsItems.vue?vue&type=style&index=0&id=3b1b6fc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports